import DataCenter from './index';
import Balance from './components/Balance.vue';
import Contract from './components/Contract.vue';
import Current from './components/Current.vue';
import Pledge from './components/Pledge.vue';
import TradeFee from './components/TradeFee.vue';
import TribeProfit from './components/TribeProfit.vue';
import User from './components/User.vue';
import WalletBill from './components/WalletBill.vue';
import DepositWithdrawVisual from './components/DWVisual';
import StakingData from './components/StakingData.vue';
import TradeVolume from './components/TradeVolume.vue';
import ListingApply from './components/ListingApply.vue';
import DwSummary from './components/DwSummary.vue';
import RechangeReturn from './components/RechangeReturn.vue';

export default {
    path: '/datacenter',
    component: DataCenter,
    children: [
        {
            path: '/datacenter/balance',
            component: Balance
        },
        {
            path: '/datacenter/contract',
            component: Contract
        },
        {
            path: '/datacenter/current',
            component: Current
        },
        {
            path: '/datacenter/pledge',
            component: Pledge
        },
        {
            path: '/datacenter/tradefee',
            component: TradeFee
        },
        {
            path: '/datacenter/tribeprofit',
            component: TribeProfit
        },
        {
            path: '/datacenter/tradeVoulmeData',
            component: TradeVolume
        },
        {
            path: '/datacenter/stakingData',
            component: StakingData
        },
        {
            path: '/datacenter/listingApply',
            component: ListingApply
        },
        {
            path: '/datacenter/user',
            component: User
        },
        {
            path: '/datacenter/walletbill',
            component: WalletBill
        },
        {
            path: '/datacenter/dw/visual',
            component: DepositWithdrawVisual
        },
        {
            path: '/datacenter/dwsummary',
            component: DwSummary
        },
        {
            path: '/datacenter/rechangeReturn',
            component: RechangeReturn
        }
    ]
};
